import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountInput", "commentInput", "difference", "confirmButton", "invalidValueMessage"]
  static values = {
    transactionAmount: String,
    currency: { type: String, default: "EUR" },
    remainingLabel: { type: String, default: "Reste à allouer :" },
    overpaymentLabel: { type: String, default: "Trop-perçu :" },
    // An inexact lettering (this form) may only be confirmed by an admin_billing user.
    allowInexact: { type: Boolean, default: true }
  }

  updateDifference() {
    let paymentSum = this.calculatePaymentSum()
    let diff = this.calculateDiff(paymentSum)
    this.updateModalUI(diff)
  }

  updateRow(event) {
    let input = event.target
    let paymentAmount = parseFloat(input.dataset.paymentAmount)
    let enteredAmount = parseFloat(input.value) || 0
    let row = input.closest(".payment-row")

    let commentWrapper = row.querySelector("[data-comment-wrapper]")
    if (enteredAmount > paymentAmount) {
      commentWrapper.classList.remove("d-none")
    } else {
      commentWrapper.classList.add("d-none")
    }

    let balanceEl = row.querySelector("[data-row-balance]")
    let balance = paymentAmount - enteredAmount
    if (balance > 0.001) {
      balanceEl.textContent = `${this.remainingLabelValue} ${this.formatCurrency(balance)}`
      balanceEl.className = "small mb-0 text-success"
    } else if (balance < -0.001) {
      balanceEl.textContent = `${this.overpaymentLabelValue} ${this.formatCurrency(Math.abs(balance))}`
      balanceEl.className = "small mb-0 text-warning"
    } else {
      balanceEl.className = "small mb-0 d-none"
    }
  }

  calculatePaymentSum() {
    return this.amountInputTargets.reduce(
      (partialSum, elt) => partialSum + (parseFloat(elt.value) || 0)
    , 0)
  }

  calculateDiff(paymentSum) {
    return parseFloat(this.transactionAmountValue) - paymentSum
  }

  invalidValues() {
    return this.amountInputTargets.some(input => parseFloat(input.value) <= 0)
  }

  hasEmptyVisibleComments() {
    return this.commentInputTargets.some(textarea => {
      let wrapper = textarea.closest("[data-comment-wrapper]")
      return !wrapper.classList.contains("d-none") && textarea.value.trim() === ""
    })
  }

  formatCurrency(amount) {
    return amount.toLocaleString('fr-FR', { style: 'currency', currency: this.currencyValue })
  }

  updateModalUI(diff) {
    this.differenceTarget.innerText = this.formatCurrency(diff)
    let parent = this.differenceTarget.parentElement
    // This form is always an inexact lettering, so only admin_billing users may confirm it.
    if (parseFloat(diff.toFixed(2)) === 0.00 && !this.invalidValues() && !this.hasEmptyVisibleComments() && this.allowInexactValue) {
      this.confirmButtonTarget.disabled = false
      parent.classList.remove("text-danger")
    } else {
      this.confirmButtonTarget.disabled = true
      parent.classList.add("text-danger")
    }

    if (this.invalidValues()) {
      this.invalidValueMessageTarget.classList.remove("d-none")
    } else {
      this.invalidValueMessageTarget.classList.add("d-none")
    }
  }
}
